<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Atendente:"
    id="selectResponsavel"
    placeholder="Selecione o Atendente do Atendimento"
    :multiple="false"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  name: 'NxSelectResponsavelAtendimento',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null,
      account: {
        administrador: true,
        permissoes: [],
        funcionario: {
          paId: []
        }
      }
    }
  },
  created () {
    this.onLoadOperador()
  },
  methods: {
    async onLoadOperador () {
      if (!this.account) {
        console.error('Account is not defined')
        return
      }

      var requestConfig = {}
      if (this.account.administrador) {
        requestConfig = {
          permissions: [],
          paId: [],
          isAdm: this.account.administrador
        }
      } else {
        requestConfig = {
          permissions: this.account.permissoes,
          paId: this.account.funcionario.paId,
          isAdm: false
        }
      }

      try {
        const response = await AtendimentoRepository.GetUsenames(requestConfig)
        const { data } = response
        this.listOptions = data.usernames.map(username => {
          return { text: username.nome, value: username.id }
        })
      } catch (error) {
        toast.error('Não foi possível carregar a lista de Operadores', 'Erro')
        console.error(error)
      }
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectResponsavelAtendimento.vue